import React from 'react'
import { connect } from 'react-redux'

import { unlistedConsultantsSelector } from 'selectors'
import { fetchUnlistedConsultants } from 'actions'

import ConsultantList from 'components/ConsultantList'

class Unlisted extends React.Component {
  componentDidMount = () => this.props.fetchUnlistedConsultants()

  render() {
    return (
      <ConsultantList
        title={count => (count === 1 ? 'ny konsulent' : 'nye konsulenter')}
        consultantIds={this.props.consultantIds}
      />
    )
  }
}

const mapStateToProps = state => ({
  consultantIds: unlistedConsultantsSelector(state) || [],
})

const mapDispatchToProps = { fetchUnlistedConsultants }

export default connect(mapStateToProps, mapDispatchToProps)(Unlisted)



// WEBPACK FOOTER //
// ./src/pages/Unlisted.js